import { render, staticRenderFns } from "./CheckPill.vue?vue&type=template&id=f1bf5a16"
import script from "./CheckPill.vue?vue&type=script&lang=js"
export * from "./CheckPill.vue?vue&type=script&lang=js"
import style0 from "./CheckPill.vue?vue&type=style&index=0&id=f1bf5a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports